import {
  TextField,
  NumberField,
  DateField,
  useListContext,
} from 'react-admin'
import DriverPayroll from './driver-payroll'
import { Datagrid } from '../../custom'
import { GridExpand } from '../../shared'
import {
  currencyFieldOptions,
  dateFieldOptions,
} from '../../util/component-options'
import { useLabel } from '../../../hooks'

const Expand = (props) => (
  <GridExpand {...props}>
    <DriverPayroll/>
  </GridExpand>
)

const BrokerDriverPayRollupsDatagrid = ({ isPrintView }) => {
  const context = useListContext()
  const label = useLabel(context)

  return (
    <Datagrid
      hasEdit={false}
      expand={isPrintView ? undefined : <Expand />}
    >
      <TextField source='driver.name' label={label('driver')} sortBy='driver_name' />
      <NumberField source='regular_total_in_dollars' label={label('regular_total_in_dollars')} options={currencyFieldOptions} />
      <NumberField source='overtime_total_in_dollars' label={label('overtime_total_in_dollars')} options={currencyFieldOptions} />
      <NumberField source='doubletime_total_in_dollars' label={label('doubletime_total_in_dollars')} options={currencyFieldOptions} />
      <NumberField source='total_in_dollars' label={label('total_in_dollars')} options={currencyFieldOptions} />
      <DateField source='period.end_date' label={label('period_end_date')} options={dateFieldOptions} sortBy='period_end_date' />
    </Datagrid>
  )
}

export default BrokerDriverPayRollupsDatagrid
